// services/api/ogrenciDuyuruService.ts
import axios, { AxiosError } from "axios";
import { ApiResponse } from "../../types/BaseModals/ApiResponse";
import { API_URL } from "../../constants/API_URL";
import { DuyuruError } from "../../types/ErrorModals/DuyuruError";
import { DuyuruRequestModal } from "../../types/RequestModals/DuyuruRequestModal";
import { DuyuruResponseModal } from "../../types/modals";

export const getOgrenciDuyuru = async (
  request: DuyuruRequestModal
): Promise<DuyuruResponseModal[]> => {
  try {
    const response = await axios.post<ApiResponse<DuyuruResponseModal[]>>(
      `${API_URL}/api/OgrenciDuyuru/getOgrenciDuyuru`,
      request
    );
    
    if (!response.data.success) {
      throw new Error(response.data.message);
    }
    
    return response.data.data!;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      const responseData = axiosError.response?.data;
      
      if (axiosError.response?.status === 404) {
        throw {
          message: responseData?.message || "Öğrenci duyurusu bulunamadı",
          correlationId: responseData?.correlationId,
        } as DuyuruError;
      }
      
      if (axiosError.response?.status === 400) {
        throw {
          message: responseData?.message || "Geçersiz istek",
          errors: responseData?.errors,
          correlationId: responseData?.correlationId,
        } as DuyuruError;
      }
      
      throw {
        message: responseData?.message || "Bir hata oluştu",
        correlationId: responseData?.correlationId,
        additionalData: responseData?.additionalData,
      } as DuyuruError;
    }
    
    throw {
      message: "Beklenmeyen bir hata oluştu",
    } as DuyuruError;
  }
};